import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api, type Event, type PaginatedResponse } from '../api/client';

export function useEvents(page = 1, limit = 20) {
  return useQuery<PaginatedResponse<Event>>({
    queryKey: ['events', page, limit],
    queryFn: () => api.events.list(page, limit),
  });
}

export function useEvent(eventId: string | undefined) {
  return useQuery<Event>({
    queryKey: ['event', eventId],
    queryFn: () => api.events.get(eventId!),
    enabled: !!eventId,
  });
}

export function useCreateEvent() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Omit<Event, 'id' | 'status' | 'billingEstimate'>) =>
      api.events.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['events'] });
    },
  });
}

export function useDeleteEvent() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (eventId: string) => api.events.delete(eventId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['events'] });
    },
  });
}
